export class ApiUnreachableError extends Error {
    public override name = ApiUnreachableError.name;
    public constructor() {
        super('Api is unreachable');
    }
}
